import { useTranslation } from 'react-i18next';
import { store } from 'src/state/dynamic-store';
import { RootState } from '@state/root-state.ts';
import { useSelector } from 'react-redux';

import Paper from '@mui/material/Paper';
import styles from './ReportImagesPage.module.scss';
import { ReportImagesComponentWrapper } from '@sharedComponents/report-images/components/main/ReportImagesComponentWrapper';
import { CdfBreadcrumbs } from '@commonComponents/navigation/CdfBreadcrumbs';

export function ReportImagesPage() {
  const { t } = useTranslation(['layouts']);
  const organizationId = useSelector((state: RootState) => state.appContext.selectedOrganizationId) ?? '';

  return (
    <>
      <CdfBreadcrumbs items={[{ label: t('breadCrumbs.reportImages.page') }]} />
      <Paper className={styles.container}>
        <ReportImagesComponentWrapper organizationId={organizationId} store={store} />
      </Paper>
    </>
  );
}
